export default [
  {
    page: 1,
    type: 'step',
    list: [{ number: 1 }, { number: 2 }, { number: 3 }, { number: 4 }, { number: 5 }],
  },
  {
    page: 2,
    type: 'step',
    list: [{ number: 6 }, { number: 7 }],
  },
  {
    page: 3,
    type: 'textarea',
    list: [{ number: 8 }],
  },
  {
    page: 4,
    type: 'textarea',
    list: [{ number: 9 }],
  },
  {
    page: 5,
    type: 'textarea',
    list: [{ number: 10 }],
  },
  {
    page: 6,
    type: 'flag',
    list: [{ number: 'allow_share' }],
  },
  {
    page: 7,
    type: 'flag',
    list: [{ number: 'submit' }],
  },
];
